export const updateReadFlagById = (items, targetItemId) => {
  const targetIndex = items.findIndex((item) => item.id === targetItemId);

  if (targetIndex === -1) {
    return items;
  }

  const targetItem = items[targetIndex];

  if (targetItem.read_flag) {
    return items;
  }

  const nextItems = [...items];
  nextItems[targetIndex] = {
    ...targetItem,
    read_flag: true,
  };

  return nextItems;
};